import SerpFiltersModal from "./SerpFiltersModal";
import {MultiSelector} from "../../components/core/Dropdown/MultiSelector";
import {LinearMultiSelector} from "../../components/core/Dropdown/LinearMultiSelector";
import {SelectWithInput} from "../../components/core/Dropdown/SelectWithInput";
import FiltersFormBar from "./FiltersFormBar";
import {WlDropdown} from "../../webcomponents/dropdown/dropdown";
import {WlSubmit} from "../../webcomponents/events/WlSubmit";
import {Autocomplete} from "../../core/autocomplete/Autocomplete";
import RemovableFilters from "./RemovableFilters";

export default class SerpFilters {
    private readonly filtersForm: FiltersFormBar;
    public searchedItems: Array<HTMLInputElement>;
    public firstFilter: boolean;

    public constructor(filtersFormBar: FiltersFormBar) {
        this.filtersForm = filtersFormBar;
        this.searchedItems = new Array<HTMLInputElement>();
        this.firstFilter = true;

        setTimeout(() => this.subscribeWebComponents(), 100);
    }

    public init = () => {
        document.querySelectorAll(".wl-selector-container:has(.wl-checkbox-select-input)")
            .forEach(it => new SelectWithInput(it as HTMLElement, () => {}));

        document.querySelectorAll(".wl-selector-container:has(.wl-checkbox-multi-select)")
            .forEach(it => new MultiSelector(it as HTMLElement));

        document.querySelectorAll(".wl-linear-multi-selector")
            .forEach(it => new LinearMultiSelector(it as HTMLElement));

        new Autocomplete().register(this.submit.bind(this));

        let serpFiltersModal = new SerpFiltersModal();
        serpFiltersModal.init(this.submit.bind(this));
        setTimeout(() => this.configureTypesChange(serpFiltersModal), 0);
        new RemovableFilters(this.filtersForm)

    }

    private configureTypesChange(serpFiltersModal: SerpFiltersModal) {
        let propertyTypes = document.querySelectorAll<WlDropdown>(".filter-types");
        if (propertyTypes.length > 0) {
            serpFiltersModal.changeAmenitiesVisibility((propertyTypes[0]).value.split(","))
        }
    }

    private subscribeWebComponents() {
        let filters = document.querySelectorAll(".js_filter:not(.serp-filters-modal  *)");
        filters.forEach((element: Node) => (element as HTMLElement).addEventListener(WlSubmit.type, this.submit.bind(this)))
    }

    private submit() {
        this.filtersForm.submit();
    }
}
